import { render, staticRenderFns } from "./babyCard.vue?vue&type=template&id=0ca4d199&scoped=true"
import script from "./babyCard.vue?vue&type=script&lang=js"
export * from "./babyCard.vue?vue&type=script&lang=js"
import style0 from "./babyCard.vue?vue&type=style&index=0&id=0ca4d199&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4d199",
  null
  
)

export default component.exports